import Import from './Import.vue'
import ImportsList from './ImportsList.vue'
import CreateImport from './CreateImport.vue'
import ImportDetails from './ImportDetails.vue'
import ImportInvoices from './ImportInvoices.vue'
import ValidationReports from './ValidationReports.vue'

export default {
    path: 'imports', component: Import, children:[
        {
            path:'', component: ImportsList, meta: { protected: true }
        },
        {
            path:'create', component: CreateImport,
        },
        {
            path:':id', component: ImportDetails, children:[
                {path:'', component: ImportInvoices},
                {path: 'validation', component: ValidationReports}
            ]
        }
    ]
}

